import { BookOpen, Loader2, X } from 'lucide-react';
import { usePresaleSheetConfig } from '../hooks/usePresaleSheetConfig';
import { PresaleSheetEditor } from './PresaleSheetEditor';
import { PresaleSheetPreview } from './PresaleSheetPreview';

interface PresaleSheetPanelProps {
  warrantyUuid: string;
  warrantyName: string | null;
  onClose: () => void;
}

/**
 * Modal d'edition de la brochure avant-vente affichee depuis WarrantyDetailPage.
 * Charge la config persistee puis affiche l'editeur (gauche) + la preview PDF (droite).
 */
export function PresaleSheetPanel({ warrantyUuid, warrantyName, onClose }: PresaleSheetPanelProps) {
  const { data: config, isLoading } = usePresaleSheetConfig(warrantyUuid);

  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-black/50 tw-p-4">
      <div className="tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-w-full tw-max-w-4xl tw-max-h-[90vh] tw-overflow-hidden tw-flex tw-flex-col">
        {/* Header */}
        <div className="tw-flex tw-items-center tw-justify-between tw-p-5 tw-border-b tw-border-gray-200">
          <div className="tw-flex tw-items-center tw-gap-3">
            <BookOpen className="tw-w-5 tw-h-5 tw-text-affinicar-primary" />
            <h3 className="tw-text-lg tw-font-bold tw-text-gray-900 tw-mb-0">
              Brochure avant vente{warrantyName ? ` — ${warrantyName}` : ''}
            </h3>
          </div>
          <button
            onClick={onClose}
            className="tw-p-1.5 tw-rounded-lg hover:tw-bg-gray-100 tw-transition-colors"
          >
            <X className="tw-w-5 tw-h-5 tw-text-gray-500" />
          </button>
        </div>

        {/* Body */}
        {isLoading || !config ? (
          <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
            <Loader2 className="tw-w-6 tw-h-6 tw-animate-spin tw-text-affinicar-primary" />
            <span className="tw-ml-3 tw-text-sm tw-text-gray-500">Chargement de la configuration...</span>
          </div>
        ) : (
          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-6 tw-p-5 tw-overflow-y-auto">
            <div className="tw-space-y-4">
              <PresaleSheetEditor
                warrantyUuid={warrantyUuid}
                initialConfig={config}
                variant="panel"
              />
            </div>
            <div>
              <PresaleSheetPreview
                key={warrantyUuid}
                warrantyUuid={warrantyUuid}
                warrantyName={warrantyName}
                initialConfig={config}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
